import { render, staticRenderFns } from "./MilestoneModal.vue?vue&type=template&id=153f50f9&scoped=true&"
import script from "./MilestoneModal.vue?vue&type=script&lang=js&"
export * from "./MilestoneModal.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneModal.vue?vue&type=style&index=0&id=153f50f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153f50f9",
  null
  
)

export default component.exports